exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.reload-btn[data-v-9ccaeb84] {\n    position: absolute;\n    right: 0;\n    top: 0;\n    margin: 12px 32px;\n}\n.clickable[data-v-9ccaeb84] {\n    cursor: pointer;\n}\n", ""]);

// exports
